// Máscara para o campo da url da loja no formulário de integração
(function () {
  'use strict';
  $('#sfy_url_loja').on('input change', function () {
    let sfy_domain = $(this).val();
    // Remove 'www', 'http://' e 'https://'
    sfy_domain = sfy_domain.toLowerCase().replace(/www\.|http:\/\/|https:\/\//g, '');
    $(this).val(sfy_domain);
  });
})();

// Ao clicar no botão para sincronizar o produto com a Shopify na página do produto
(function () {
  'use strict';
  $('.btn-sync-prod-shpoify').on('click', function (ev) {
    ev.preventDefault();
    showConfirm({
      type: 'warning',
      title: 'Sincronizar com a Shopify',
      text: 'Deseja sincronizar as informações deste produto com a Shopify?',
      confirmButtonText: 'Sincronizar',
      cancelButtonText: 'Cancelar',
      callback: function () {
        $('.btn-sync-prod-shpoify').prop('disabled', true).html('<div class="btn-spinner dark"></div> Aguarde...');
        $('#form-sync-prod-shopify').submit();
      },
    });
  });
})();
